import React from 'react';
import Modal from 'react-modal';

import CodeMirror from 'react-codemirror';
import 'codemirror/mode/htmlmixed/htmlmixed';
import 'codemirror/lib/codemirror.css';

import Switch from 'react-toggle-switch';
import 'react-toggle-switch/dist/css/switch.min.css';

import DismissButton from './styled/DismissButton';
import ActionButton from './styled/ActionButton';
import P from './styled/Instructions';
import ModalStyles from './styled/Modal';
import CodeMirrorStyles from './styled/CodeMirror';
import SwitchStyles from './styled/Switch';

const Input = (props) => {
  const {dangerous, code, open} = props;
  return (
    <Modal
      isOpen={open}
      onRequestClose={props.reset}
      className={ModalStyles}
      ariaHideApp={false}
    >
      <DismissButton
        onClick={() => { props.reset(); }}
      />
      <P>Add your embed code below:</P>
      <CodeMirror
        options={{
          mode: 'htmlmixed',
          lineNumbers: true,
        }}
        value={code}
        onChange={props.updateCode}
        className={CodeMirrorStyles}
      />
      <div>
        <ActionButton
          dangerous={dangerous}
          onClick={props.embedCode}
        >
          {dangerous ? 'Dangerously Embed Inline' : 'Embed'}
        </ActionButton>
        <Switch
          onClick={props.updateDangerous}
          on={dangerous}
          className={SwitchStyles}
        >
          <i className='fas fa-exclamation' />
        </Switch>
      </div>
    </Modal>
  );
};

export default Input;
